import { Id, UUID } from '@cna/shared/generic-types';
import { ControlTest } from '../control-test/control-test';
import { Course } from './course';

export enum LearnModuleType {
    Module = 'MODULE',
    Repetitorium = 'REPETITORIUM',
}

export interface LearnModule {
    id?: UUID; //extend "BaseEntity" ging nicht -> Property "id" not in LearnModule
    createdAt?: Date | string;
    updatedAt?: Date | string;
    associatedCourse: Course | UUID | Id;
    /**
     * Number of Module (1-6)
     */
    sequentialNumber: number | null;

    name: string;
    type: LearnModuleType;

    /**
     * Id of the corresponding (manual composed) "book"
     */
    moduleDocumentTemplateId: UUID | null;

    controlTest?: ControlTest;
    controlTestId?: UUID;
    controlTestCourseParticipationId?: UUID;
    unlocked?: boolean;
    percentageRead?: number;
    controlTestPassed?: boolean;
    totalTimeRead?: number;
    targetReadingTime?: number;
}
